import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const AssetLevelListHeader = ({ canAdd = false, companyId = '', subcompanyId = '', t }) => {
  return <Common.Header title={t('asset_level.title')}></Common.Header>;
};

export default translate()(AssetLevelListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/components/list/AssetLevelListHeader.js